import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  behaviorLoading = new BehaviorSubject<boolean>(false);

  loading(value: boolean): void {
    this.behaviorLoading.next(value);
  }

}
